export const safet = require('./Safe-T/Safe-T.JPG');
export const safet2 = require('./Safe-T/Safe-T2.JPG');
export const safet3 = require('./Safe-T/Safe-T3.JPG');
export const safet4 = require('./Safe-T/Safe-T4.JPG');
export const safet5 = require('./Safe-T/Safe-T5.JPG');
export const safet6 = require('./Safe-T/Safe-T6.JPG');
export const safet7 = require('./Safe-T/Safe-T7.JPG');
export const safet8 = require('./Safe-T/Safe-T8.jpg');
export const safet9 = require('./Safe-T/Safe-T9.jpg');
export const safet10 = require('./Safe-T/Safe-T10.jpg');
export const safet11 = require('./Safe-T/Safe-T11.jpg');
export const safet12 = require('./Safe-T/Safe-T12.jpg');
export const safet13 = require('./Safe-T/Safe-T13.jpg');
export const safet14 = require('./Safe-T/Safe-T14.jpg');
export const safet15 = require('./Safe-T/Safe-T15.jpg');
export const safet16 = require('./Safe-T/Safe-T16.jpg');
export const safet17 = require('./Safe-T/Safe-T17.jpg');
export const safet18 = require('./Safe-T/Safe-T18.jpg');
export const safet19 = require('./Safe-T/Safe-T19.jpg');
export const safet20 = require('./Safe-T/Safe-T20.jpg');
export const safet21 = require('./Safe-T/Safe-T21.jpg');
export const safet22 = require('./Safe-T/Safe-T22.jpg');
export const safet23 = require('./Safe-T/Safe-T23.jpg');
export const safet24 = require('./Safe-T/Safe-T24.jpg');
export const safet25 = require('./Safe-T/Safe-T25.jpg');
export const safet26 = require('./Safe-T/Safe-T26.jpg');
export const safet27 = require('./Safe-T/Safe-T27.jpg');
export const safet28 = require('./Safe-T/Safe-T28.jpg');
export const safet29 = require('./Safe-T/Safe-T29.jpg');
export const safet30 = require('./Safe-T/Safe-T30.jpg');
export const vpbx = require('./VirtualPBX/VirtualPBX.JPG');
export const vpbx2 = require('./VirtualPBX/VirtualPBX2.JPG');
export const vpbx3 = require('./VirtualPBX/VirtualPBX3.JPG');
export const vpbx4 = require('./VirtualPBX/VirtualPBX4.JPG');
export const vpbx5 = require('./VirtualPBX/VirtualPBX5.JPG');
export const vpbx6 = require('./VirtualPBX/VirtualPBX6.JPG');
export const vpbx7 = require('./VirtualPBX/VirtualPBX7.jpg');
export const vpbx8 = require('./VirtualPBX/VirtualPBX8.jpg');
export const vpbx9 = require('./VirtualPBX/VirtualPBX9.JPG');
export const vpbx10 = require('./VirtualPBX/VirtualPBX10.jpg');
export const vpbx11 = require('./VirtualPBX/VirtualPBX11.JPG');
export const vpbx12 = require('./VirtualPBX/VirtualPBX12.JPG');
export const vpbx13 = require('./VirtualPBX/VirtualPBX13.jpg');
export const vpbx14 = require('./VirtualPBX/VirtualPBX14.jpg');
export const vpbx15 = require('./VirtualPBX/VirtualPBX15.JPG');
export const vpbx16 = require('./VirtualPBX/VirtualPBX16.jpg');
export const iod = require('./IoD/IoD.jpg');
export const iod2 = require('./IoD/IoD2.jpg');
export const iod3 = require('./IoD/IoD3.jpg');
export const iod4 = require('./IoD/IoD4.jpg');
export const iod5 = require('./IoD/IoD5.jpg');
export const iod6 = require('./IoD/IoD6.jpg');
export const iod7 = require('./IoD/IoD7.jpg');
export const iod8 = require('./IoD/IoD8.jpg');
export const bod = require('./BoD/BoD.JPG');
export const bod2 = require('./BoD/BoD2.JPG');
export const bod3 = require('./BoD/BoD3.JPG');
export const bod4 = require('./BoD/BoD4.JPG');
export const bod5 = require('./BoD/BoD5.JPG');
export const bod6 = require('./BoD/BoD6.JPG');
export const bod7 = require('./BoD/BoD7.JPG');
export const bod8 = require('./BoD/BoD8.JPG');
export const roompi = require('./RoomPi/RoomPi.JPG');
export const roompi2 = require('./RoomPi/RoomPi2.JPG');
export const roompi3 = require('./RoomPi/RoomPi3.JPG');
export const roompi4 = require('./RoomPi/RoomPi4.jpg');
export const roompi5 = require('./RoomPi/RoomPi5.jpg');
export const daloradius = require('./daloRadius/daloRadius.JPG');
export const daloradius2 = require('./daloRadius/daloRadius2.JPG');
export const daloradius3 = require('./daloRadius/daloRadius3.JPG');
export const agreefisheries = require('./AgreeFisheries/AgreeFisheries.png');
export const agreefisheries2 = require('./AgreeFisheries/AgreeFisheries2.jpg');
export const agreefisheries3 = require('./AgreeFisheries/AgreeFisheries3.jpg');
export const agreefisheries4 = require('./AgreeFisheries/AgreeFisheries4.jpg');
export const agreefisheries5 = require('./AgreeFisheries/AgreeFisheries5.jpg');
export const agreefisheries6 = require('./AgreeFisheries/AgreeFisheries6.jpg');
export const agreefisheries7 = require('./AgreeFisheries/AgreeFisheries7.jpg');
export const agreefisheries8 = require('./AgreeFisheries/AgreeFisheries8.jpg');
export const agreefisheries9 = require('./AgreeFisheries/AgreeFisheries9.jpg');
export const agreefisheries10 = require('./AgreeFisheries/AgreeFisheries10.jpg');
export const agreefisheries11 = require('./AgreeFisheries/AgreeFisheries11.jpg');
export const agreefisheries12 = require('./AgreeFisheries/AgreeFisheries12.jpg');
export const agreefisheries13 = require('./AgreeFisheries/AgreeFisheries13.jpg');
export const agreefisheries14 = require('./AgreeFisheries/AgreeFisheries14.jpg');
export const agreefisheries15 = require('./AgreeFisheries/AgreeFisheries15.jpg');
export const agreefisheries16 = require('./AgreeFisheries/AgreeFisheries16.jpg');
export const agreefisheries17 = require('./AgreeFisheries/AgreeFisheries17.jpg');
export const agreefisheries18 = require('./AgreeFisheries/AgreeFisheries18.jpg');
export const agreefisheries19 = require('./AgreeFisheries/AgreeFisheries19.jpg');
export const agreefisheries20 = require('./AgreeFisheries/AgreeFisheries20.jpg');
export const agreefisheries21 = require('./AgreeFisheries/AgreeFisheries21.jpg');
export const agreefisheries22 = require('./AgreeFisheries/AgreeFisheries22.jpg');
export const agreefisheries23 = require('./AgreeFisheries/AgreeFisheries23.jpg');
export const agreefisheries24 = require('./AgreeFisheries/AgreeFisheries24.jpg');
export const agreefisheries25 = require('./AgreeFisheries/AgreeFisheries25.jpg');
export const agreefisheries26 = require('./AgreeFisheries/AgreeFisheries26.jpg');
export const agreefisheries27 = require('./AgreeFisheries/AgreeFisheries27.jpg');
export const agreefisheries28 = require('./AgreeFisheries/AgreeFisheries28.jpg');
export const agreefisheries29 = require('./AgreeFisheries/AgreeFisheries29.jpg');
export const agreefisheries30 = require('./AgreeFisheries/AgreeFisheries30.jpg');
export const agreefisheries31 = require('./AgreeFisheries/AgreeFisheries31.jpg');
export const agreefisheries32 = require('./AgreeFisheries/AgreeFisheries32.jpg');
export const agreefisheries33 = require('./AgreeFisheries/AgreeFisheries33.jpg');
export const agreefisheries34 = require('./AgreeFisheries/AgreeFisheries34.jpg');
export const agreefisheries35 = require('./AgreeFisheries/AgreeFisheries35.jpg');
export const agreefisheries36 = require('./AgreeFisheries/AgreeFisheries36.jpg');
export const majoocrm = require('./MajooCRM/MajooCRM.png');
export const majoocrm2 = require('./MajooCRM/MajooCRM2.png');
export const majoocrm3 = require('./MajooCRM/MajooCRM3.png');
export const majoocrm4 = require('./MajooCRM/MajooCRM4.png');
export const majoocrm5 = require('./MajooCRM/MajooCRM5.png');
export const majoocrm6 = require('./MajooCRM/MajooCRM6.png');
export const majoocrm7 = require('./MajooCRM/MajooCRM7.png');
export const majoocrm8 = require('./MajooCRM/MajooCRM8.png');
export const majoocrm9 = require('./MajooCRM/MajooCRM9.png');
export const majoocrm10 = require('./MajooCRM/MajooCRM10.png');
export const majoocrm11 = require('./MajooCRM/MajooCRM11.png');
export const majoocrm12 = require('./MajooCRM/MajooCRM12.png');
export const majoocrm13 = require('./MajooCRM/MajooCRM13.png');
export const majoocrm14 = require('./MajooCRM/MajooCRM14.png');
export const majoocrm15 = require('./MajooCRM/MajooCRM15.png');
export const majoocrm16 = require('./MajooCRM/MajooCRM16.png');
export const majoocrm17 = require('./MajooCRM/MajooCRM17.png');
export const majoocrm18 = require('./MajooCRM/MajooCRM18.png');
